import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const formContainer = this.element.querySelector('#magic-link-form');
    const feedbackContainer = this.element
      .querySelector('#magic-link-feedback');
    formContainer.style.display = 'block';
    feedbackContainer.style.display = 'none';

    formContainer.querySelector('form')
      .addEventListener('ajax:success', () => {
        formContainer.style.display = 'none';
        feedbackContainer.style.display = 'block';
        const emailElement = document.getElementById('email');
        const display = document.getElementById('magic-link-form-email-display');
        if (emailElement !== null && display !== null) {
          display.textContent = emailElement.value || '';
        }
        this.element.dispatchEvent(
          new Event('magicLinkForm:submitted', { bubbles: true }),
        );
      });
  }
}
